import React, { useState, useRef } from 'react';
import Select from 'react-select';
import type { SelectItem } from '../../../../../models/select/selectItem';
import { fromCompany } from '../../../../../models/select/selectItem';
import type { Company } from '../../../../../models/companies/company';

interface Props {
  companies: Company[];
  inputName?: string;
  className?: string;
  defaultCompanyId: number | null;
  placeholder?: string;
}

export default function SelectCompaniesView(props: Props) {
  const { companies, inputName, className, defaultCompanyId, placeholder } =
    props;
  const [options] = useState<SelectItem[]>(() => fromCompany(companies));
  const [selectedOption, setSelectedOption] = useState<SelectItem | null>(
    () => options.find(item => item.value === defaultCompanyId) || null,
  );
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- react-select の ref 型が定まらないため any を使う
  const selectRef = useRef<any>(null);

  const handleChangeValue = (data: SelectItem | null) => {
    setSelectedOption(data);
  };

  // 事業者を選択時にEnter押すとPOSTリクエストが飛んでしまうため、そうならないようにEnter押下時の処理を追加
  const onKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    const { select } = selectRef.current;
    const { focusedOption } = select.state;

    switch (event.key) {
      case 'Enter':
        event.preventDefault();
        if (!select.props.menuIsOpen) {
          selectRef.current.setState({
            menuIsOpen: true,
          });
          break;
        } else {
          if (!focusedOption) return;
          if (select.isComposing) return;
          select.selectOption(focusedOption);
          break;
        }
    }
  };

  return (
    <Select
      value={selectedOption}
      name={inputName}
      className={className}
      ref={selectRef}
      isClearable={true}
      onChange={handleChangeValue}
      onKeyDown={onKeyDown}
      options={options}
      noOptionsMessage={() => '選択可能な銘柄がありません。'}
      placeholder={placeholder || ''}
    />
  );
}
